/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { CarouselSlider } from '@/components/blocks/Carousel';
import { ProgressIndicator } from '@/components/blocks/ProgressIndicator';
import { RenderContent } from '@/components/blocks/RenderContent';
import { useContentCarousel } from '@/data/Content/ContentCarousel';
import { useContentEvents } from '@/data/Content/_ContentEvents';
import { ID } from '@/data/types/Basic';
import { WidgetProperties } from '@/data/types/Slot';
import { renderContent } from '@/utils/renderContent';
import { Box } from '@mui/material';
import { FC, useMemo } from 'react';

const emptyProperties = {} as WidgetProperties;

export const ContentCarousel: FC<{ id: ID; properties?: WidgetProperties }> = ({
	id: _id,
	properties = emptyProperties,
}) => {
	const { emsName = '' } = properties;
	const { data, title, loading } = useContentCarousel(emsName);
	const { onContentClick } = useContentEvents();

	const slides = useMemo(
		() =>
			(data || [])
				.map((c, index) => renderContent(c, onContentClick(c), index === 0))
				.filter(Boolean),
		[data, onContentClick]
	) as JSX.Element[];

	return (
		<>
			{loading ? (
				<ProgressIndicator />
			) : (
				<Box>
					{title?.map((content, index) => (
						<RenderContent
							key={`${content.id}${content.contentId}`}
							content={content}
							onClick={onContentClick(content)}
							priority={index === 0}
						/>
					))}
					<CarouselSlider slides={slides}></CarouselSlider>
				</Box>
			)}
		</>
	);
};
